import { useContext, useState} from "react";
import { useNavigate} from "react-router-dom";
import { ServiceContext } from "../../../contexts/ServiceContext";
import { ReactComponent as EmailIcon } from "../../../icons/email-settings.svg";
import { ApiError } from "../../../services/ApiError";
import { AppAlert } from "../../../utils/AppAlert";

function ForgotPassword(){
    const [username, setUsername] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const { infrastructureService } = useContext(ServiceContext);
    const [loadingSave, setLoadingSave] = useState(false);
    const navigate = useNavigate();  
    
    function onCancelClick() {
      navigate("/");
    }
  
    const onSetPasswordClick = async () => {
      try{
        setLoadingSave(true);
        let body = {
                email: username
            };
        await infrastructureService.post("User/forgotPassword", body);
        navigate("/");
        AppAlert.success("We sent you an email with an invitation to set a new password for your account.");
      }catch (err) {
        if (err instanceof ApiError) {
            if (err.errors) {
                setErrorMessage(Object.values(err.errors).flat().join("\n"));
            } else {
                setErrorMessage(err.message);
            }
        } else {
            setErrorMessage(err.message || "Unexpected error");
        }
      } 
      finally{
        setLoadingSave(false);
      }
    };

    return (
    <div className="login"> 
       <div className="container">
        <div className="card">
          <div className="text">Forgot Password</div>
        </div>
        <div className="inputs">
          <div className="input">
            <EmailIcon/>
            <input type="email" placeholder="Email" onChange={(e) => setUsername(e.target.value)} value={username}/>
           </div>
          {errorMessage && (
            <div className="error input">
              <span style={{paddingLeft: "10px"}}>{errorMessage}</span>
            </div>
           )}
          <div className="submit-container">
            <div className="cancel" onClick={onCancelClick}>Cancel</div>
            {!loadingSave && (<div className="submit" type="submit" onClick={() => onSetPasswordClick()}>Submit</div>)}
            {loadingSave && (<div className="submit">Loading...</div>)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword;